import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';

const TranslationContext = createContext();

export const useTranslationContext = () => useContext(TranslationContext);

export const TranslationProvider = ({ children }) => {
    const [isTranslationLoading, setIsTranslationLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTranslations = async () => {
            try {
                const response = await fetch('/config/translations/en.json');

                if (!response.ok) {
                    throw new Error(`Unable to load static translations: ${response.status}`);
                }

                const translations = await response.json();

                if (
                    typeof translations !== 'object' ||
                    translations === null ||
                    Array.isArray(translations) ||
                    Object.keys(translations).length === 0
                ) {
                    throw new Error('Static translations must be a non-empty object');
                }

                i18n.addResourceBundle('en', 'translation', translations, true, true);

            } catch (err) {
                console.error('Error loading static translations:', err);
                setError(err);
            } finally {
                setIsTranslationLoading(false);
            }
        };
        fetchTranslations();
    }, []);

    return (
        <TranslationContext.Provider value={{ isTranslationLoading, error }}>
            {isTranslationLoading ? null : children}
        </TranslationContext.Provider>
    );
};

TranslationProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
